module.exports = __webpack_public_path__ + "static/media/break.865e38eb.png";